function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
/*********************************************************************************
 GAME UI

 Persistent game UI state owned by the engine:

 - log - an array of game updates
 - status - a single sentence describing state of processing

 HUD presentation is GameHUD2:
   this.hud.updateStatus(status)
   this.hud.updateMenu(options, callback)
   this.hud.updateCards(cards, callback)

**********************************************************************************/
var SaitoOverlay = require('./../../saito/ui/saito-overlay/saito-overlay');
var GameUI = /*#__PURE__*/function () {
  function GameUI() {
    _classCallCheck(this, GameUI);
  }
  return _createClass(GameUI, [{
    key: "updateLog",
    value: function updateLog(str) {
      var eventType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      try {
        var type = typeof eventType === 'string' ? eventType.trim() : '';
        this.game.log.unshift(type ? {
          msg: str,
          type: type,
          data: data
        } : str);
        if (this.game.log.length > this.log_length) {
          this.game.log.splice(length);
        }
        if (this.gameBrowserActive() && this.log.rendered) {
          this.log.updateLog(str, type, data);
          //
          // adds mouseover to cards in log
          //
          if (this.useCardbox) {
            this.cardbox.attachCardEvents();
          }
        }
      } catch (err) {}
    }

    ///
    // These three functions are used by Blackjack and Imperium ...
    // but were delete in refactor / readded by WASM
    // TODO: fix this
    ///
  }, {
    key: "lockInterface",
    value: function lockInterface() {
      this.lock_interface = 1;
      this.lock_interface_step = this.game.queue[this.game.queue.length - 1];
    }
  }, {
    key: "unlockInterface",
    value: function unlockInterface() {
      this.lock_interface = 0;
    }
  }, {
    key: "mayUnlockInterface",
    value: function mayUnlockInterface() {
      if (this.lock_interface_step === this.game.queue[this.game.queue.length - 1]) {
        return 1;
      }
      return 0;
    }

    ///////////////////////////////////////////////////////////////////////////////////////
    ///////////// META USER INTERFACE /////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////
  }, {
    key: "setPlayReminder",
    value: function setPlayReminder() {
      var _this = this;
      //We can assume anyone holding their phone is going to be paying attention!
      if (this.app.browser.isMobileBrowser(navigator.userAgent) || this.play_reminder) {
        return;
      }
      this.play_reminder = setTimeout(function () {
        var newOverlay = new SaitoOverlay(_this.app, _this, false, true, true);
        newOverlay.show("<div class=\"message_box\">the move is yours</div>");
        window.removeEventListener('mousemove', clearTimer);
      }, 15000);
      var clearTimer = function clearTimer() {
        clearTimeout(_this.play_reminder);
        _this.play_reminder = null;
      };
      window.addEventListener('mousemove', clearTimer, {
        once: true
      });
    }
  }, {
    key: "notifyMove",
    value: function notifyMove() {
      if (!this.gameBrowserActive() || this.ignore_notifications) {
        return;
      }

      //Flash tab
      this.app.browser.createTabNotification('New Move', this.returnName());
      //Play a sound
      this.playChime();
    }
  }, {
    key: "playChime",
    value: function playChime() {
      var _this2 = this;
      if (this.app.browser.active_tab || !this.game_move_notification) {
        return;
      }
      if (this.beeping) {
        return;
      }
      this.beeping = setTimeout(function () {
        _this2.beeping = null;
      }, 1000);
      try {
        this.game_move_notification.play();
      } catch (err) {
        console.error('ERROR: user not engaging with application', err);
      }
    }
  }, {
    key: "setShotClock",
    value: function setShotClock() {
      var _this3 = this;
      var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var timer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3000;
      var pause_on_activity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      this.clearShotClock();
      if (!target) {
        console.warn('GT [setShotClock] empty target!');
        return;
      }
      var elem = document.querySelector(target);
      if (elem) {
        this.app.browser.addElementToSelector("<div class=\"animated-mask\"></div>", target);
        this.shot_clock = setTimeout(function () {
          _this3.clearShotClock();

          //
          // the UI may have been re-rendered (or repurposed entirely, e.g. by a
          // game-over) since the clock was armed -- only auto-click a control
          // that still matches the selector we were armed for
          //
          var clickable = elem.isConnected ? elem : document.querySelector(target);
          if (!clickable) {
            console.warn("GT [setShotClock] not auto-clicking '".concat(target, "' -- control was replaced or removed"));
            return;
          }
          if (callback) {
            callback();
          }
          clickable.click();
        }, timer);
        $('.animated-mask').animate({
          width: '0px'
        }, timer);
        if (pause_on_activity) {
          document.body.addEventListener('click', function () {
            _this3.clearShotClock(false);
          }, {
            once: true
          });
        }
      } else {
        console.warn('GT [setShotClock] target not found!');
      }
    }
  }, {
    key: "clearShotClock",
    value: function clearShotClock() {
      var remove_mask = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (this.shot_clock) {
        clearTimeout(this.shot_clock);
        this.shot_clock = null;
        $('.animated-mask').stop();
      }
      if (remove_mask) {
        $('.animated-mask').remove();
      } else {
        $('.animated-mask').addClass('flash3');
      }
    }
  }, {
    key: "promptMove",
    value: function promptMove() {
      var _this4 = this;
      var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var timer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10000;
      this.clearShotClock();
      if (!target) {
        console.warn('GT [promptMove] empty target!');
        return;
      }
      var elem = document.querySelector(target);
      if (elem) {
        this.app.browser.addElementToSelector("<div class=\"animated-mask flash2\"></div>", target);
        this.shot_clock = setTimeout(function () {
          if (timer > 1000) {
            timer -= 1000;
          }
          _this4.promptMove(target, timer);
        }, timer);
      }
    }

    //////////////////////////////////////////////////////////////////////////////////////////////
    /////////////////////   END GAME USER INTERFACE   ////////////////////////////////////////////
    //////////////////////////////////////////////////////////////////////////////////////////////
  }, {
    key: "gameOverUserInterface",
    value: function gameOverUserInterface() {
      var winner = this.game.winner;
      var reason = this.game.reason;

      //Stop players from clicking more
      this.removeEvents();

      // Game is over, we don't care if people navigate away
      this.app.browser.unlockNavigation();

      /////////////////////////////////////////////////////
      // Update the Game UI to reflect the end of the game
      /////////////////////////////////////////////////////
      var readable = '';
      //Check if multiple winners, or none
      if (winner.includes(this.publicKey)) {
        readable = 'You win';
      } else {
        if (Array.isArray(winner)) {
          var _iterator = _createForOfIteratorHelper(winner),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var w = _step.value;
              readable += this.app.keychain.returnUsername(w) + ', ';
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          readable = readable.substring(0, readable.length - 2) + ' win';
          if (winner.length == 1) {
            readable += 's';
          }
        } else {
          readable = this.app.keychain.returnUsername(winner) + ' wins';
        }
      }

      //Include reason if given
      if (reason != '') {
        readable += ' by ' + reason;
      } else {
        readable += '!';
      }

      //Just state reason if no winners
      if (winner.length == 0 || reason == 'cancellation') {
        readable = reason;
      }
      readable = 'Game Over: ' + readable;
      try {
        this.hud.hideBackButton();
        this.updateLog(readable);
        this.updateStatusForGameOver(readable);
      } catch (err) {
        console.error('GT [gameoverUserInterface] Error: ', err);
      }
    }
  }, {
    key: "updateStatusForGameOver",
    value: function updateStatusForGameOver(status) {
      var _this5 = this;
      var target = this.app.options.homeModule || 'Arcade';
      this.hud.hideBackButton();
      this.game.status = status;
      this.hud.updateStatus(status);
      this.hud.updateCards([]);
      this.hud.updateMenu([{
        id: 'confirmit',
        label: "Return to ".concat(target)
      }], function (id) {
        if (id === 'confirmit') {
          _this5.exitGame();
        }
      });
    }
  }, {
    key: "updateStatusForPlayerOut",
    value: function updateStatusForPlayerOut(status) {
      var _this6 = this;
      var allowObserver = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var target = this.app.options.homeModule || 'Arcade';
      this.hud.hideBackButton();
      this.halted = 1;
      this.game.status = status;
      this.hud.updateStatus(status);
      this.hud.updateCards([]);
      this.hud.updateMenu([{
        id: 'confirmit',
        label: "Return to ".concat(target)
      }], function (id) {
        if (id === 'confirmit') {
          _this6.exitGame();
        }
      });
      this.lockInterface();
    }
  }]);
}();
module.exports = GameUI;